import { en } from './languages/en';
import { zh } from './languages/zh';
import { ru } from './languages/ru';
import { de } from './languages/de';
import { id } from './languages/id';
import { ko } from './languages/ko';
import { ja } from './languages/ja';
import { th } from './languages/th';
import { TranslationType } from './types';

export type Language = 'en' | 'zh' | 'ru' | 'de' | 'id' | 'ko' | 'ja' | 'th';

export const translations: Record<Language, TranslationType> = {
  en,
  zh,
  ru,
  de,
  id,
  ko,
  ja,
  th
}; 